import React from 'react'
import { withTranslation } from 'react-i18next'
// @ts-ignore
import Slider from 'app/components/Slider'
import Badge from 'app/components/Badge'
import Star from 'app/components/SVGS/Star'
import ButtonArrow from 'app/components/ButtonArrow'
import { ISprintEnableBlockProps, IBadge } from './interface'
import './styles.scss'
const bc = 'sprint-enabled-block'

const SprintEnabledBlock = ({ t, badges: { activeBadge, achievedBadges } }: ISprintEnableBlockProps) => {
  let badgesForRender = [...achievedBadges]
  let badgePlaceholders
  if (activeBadge) {
    badgesForRender.push(activeBadge)
  }
  const achievedBadgeNumber = badgesForRender.length
  if (achievedBadgeNumber < 5) {
    badgePlaceholders = new Array(5 - badgesForRender.length).fill('')
    badgesForRender = [...badgesForRender, ...badgePlaceholders]
  }
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    prevArrow: <ButtonArrow left buttonClass={`${bc}__prev`} />,
    nextArrow: <ButtonArrow right buttonClass={`${bc}__next`} />,
    responsive: [
      {
        breakpoint: 940,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 420,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className={achievedBadgeNumber > 5 ? `${bc}__wrapper-slider` : `${bc}__wrapper`}>
      {achievedBadgeNumber > 5 ? (
        <Slider card={Badge} items={badgesForRender} settings={sliderSettings} />
      ) : (
          badgesForRender.map((badge: IBadge, index: number) => {
            if (badge.url) {
              return (
                <Badge
                  key={`${index}_badge`}
                  url={badge.url}
                  alt={badge.label}
                  className={`${bc}__badge`}
                  isNotAchieved={badge.isNotAchieved}
                />
              )
            }
            if (index + badgePlaceholders.length >= 5) {
              return <Star key={`${index}_badge`} className={`${bc}__badge`} title={t('Upcoming award')} />
            }
          })
        )}
    </div>
  )
}

export default withTranslation('user')(SprintEnabledBlock) as React.FunctionComponent<ISprintEnableBlockProps>
